import { server } from "../../server";
import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import ExportExcel from "../../components/ExportExcel";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { getUniqueSheetName } from "../../functions";

function BusRoute() {
  const [busRoute, setBusRoute] = useState([]);
  const [busDetails, setBusDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState("");
  const MySwal = withReactContent(Swal);
  const [isEditing, setIsEditing] = useState(false);
  const [editRouteId, setEditRouteId] = useState(null);
  const [busStoppageDetails, setBusStoppageDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  const resetForm = () => {
    setFormData({
      busNo: "",
      preference: "",
      stoppage: "",
    });
    setIsEditing(false);
    setEditRouteId(null);
  };

  const [formData, setFormData] = useState({
    busNo: "",
    preference: "",
    stoppage: "",
  });

  const totalFields = Object.keys(formData).length;
  const filledFields = Object.values(formData).filter(
    (val) =>
      (typeof val === "string" && val.trim() !== "") ||
      (typeof val === "number" && val > 0)
  ).length;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleEditClick = (route) => {
    setIsEditing(true);
    setEditRouteId(route.id);
    setFormData({
      busNo: route.busNo || "",
      preference: route.preference || "",
      stoppage: route.stoppage || "",
    });

    const modalElement = document.getElementById("addRouteModal");
    if (modalElement) {
      const modal = new window.bootstrap.Modal(modalElement);
      modal.show();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedData = {};
    Object.keys(formData).forEach((key) => {
      formattedData[key] =
        typeof formData[key] === "string"
          ? formData[key].trim()
          : formData[key];
    });

    setLoading(true);

    try {
      let response;

      if (isEditing && editRouteId) {
        response = await axios.post(
          `${server}/update_busRoute_mongodb`,
          {
            id: editRouteId,
            busNo: formattedData.busNo,
            preference: formattedData.preference,
            stoppage: formattedData.stoppage,
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("Bus Route Updated", { position: "top-right" });
          setBusRoute((prev) =>
            prev.map((route) =>
              route.id === editRouteId ? { ...route, ...formattedData } : route
            )
          );
        } else {
          toast.error("Update Failed", {
            position: "top-right",
          });
        }
      } else {
        response = await axios.post(
          `${server}/addBusRouteMongoDb`,
          formattedData,
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("Bus Route Added", { position: "top-right" });
          const newRoute = response.data?.["body-json"]?.body?.route;
          if (newRoute) {
            setBusRoute((prev) => [...prev, newRoute]);
          }
        } else {
          toast.error("Add failed. Please try again.", {
            position: "top-right",
          });
        }
      }

      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) {
        closeButton.click();
      }

      setFormData({
        busNo: "",
        preference: "",
        stoppage: "",
      });
      setIsEditing(false);
      setEditRouteId(null);
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchBusStoppages = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${server}/getAllBusStoppageMongoDb`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        const stoppages = response.data?.["body-json"]?.body?.stoppages;
        if (Array.isArray(stoppages)) {
          setBusStoppageDetails(stoppages);
        } else {
          console.error("Invalid data format from API:", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus stoppages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusStoppages();
  }, []);

  useEffect(() => {
    const fetchBusRoutes = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${server}/getAllBusRoutesMongoDb`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        const routes = response.data?.["body-json"]?.body?.routes;
        if (Array.isArray(routes)) {
          setBusRoute(routes);
        } else {
          console.error("Invalid data format from API:", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus routes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusRoutes();
  }, []);

  // Filter
  const filteredRecords = busRoute.filter((driver) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(driver).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(searchLower);
      } else if (typeof value === "object" && value !== null) {
        return Object.values(value).some(
          (subValue) =>
            typeof subValue === "string" &&
            subValue.toLowerCase().includes(searchLower)
        );
      }
      return false;
    });
  });

  // ✅ Reset pagination when searching
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ Apply pagination AFTER filtering
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const columnMapping = {
    busNo: "Bus No",
    preference: "Preference",
    stoppage: "Stoppage",
  };

  const handleExportExcel = () => {
    ExportExcel(busRoute, "BusRoute", columnMapping);
  };

  useEffect(() => {
    const fetchBusDetails = async () => {
      try {
        const response = await axios.get(`${server}/allBusDetailsMongoDb`, {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        if (response.data && response.data["body-json"]?.body?.data) {
          setBusDetails(response.data["body-json"].body.data);
        } else {
          console.error("Invalid data format from API", response.data);
        }
      } catch (error) {
        console.error("Error fetching bus details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusDetails();
  }, []);

  const handleDelete = async (routeIdToDelete) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: `Do you want to delete route "${routeIdToDelete}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/delete_busRoute_mongodb",
          { id: routeIdToDelete },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          toast.success("Bus Route Deleted", { position: "top-right" });
          setBusRoute((prev) =>
            prev.filter((route) => route.id !== routeIdToDelete)
          );
        } else {
          toast.error("Please Try Again");
        }
      } catch (error) {
        toast.error("Please Try Again");
      }
    }
  };

  const handleExportBusRoutesExcel = () => {
    if (!busRoute || busRoute.length === 0) {
      toast.error("No bus route data to export");
      return;
    }

    const sheetData = busRoute.map((route) => ({
      "Bus No": route.busNo || "",
      "Vehicle No": route.vehicleNumber || "",
      Preference: route.preference || "",
      Stoppage: route.stoppage || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bus Routes");

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusRoutes_${today}.xlsx`);

    toast.success("Report Generated");
  };

  const handleExportBusRoutesBusWiseExcel = () => {
    if (!busRoute || busRoute.length === 0) {
      toast.error("No bus route data to export");
      return;
    }

    const sortedRoutes = [...busRoute].sort((a, b) => {
      const numA = parseInt(a.busNo, 10) || 0;
      const numB = parseInt(b.busNo, 10) || 0;
      return numA - numB;
    });

    const groupedByBusNo = sortedRoutes.reduce((acc, route) => {
      const busNo = route.busNo || "Unknown";
      if (!acc[busNo]) acc[busNo] = [];
      acc[busNo].push(route);
      return acc;
    }, {});

    const workbook = XLSX.utils.book_new();

    Object.entries(groupedByBusNo).forEach(([busNo, routes]) => {
      const sheetData = routes.map((route) => ({
        "Bus No": route.busNo || "",
        "Vehicle No": route.vehicleNumber || "",
        Preference: route.preference || "",
        Stoppage: route.stoppage || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(sheetData);
      const sheetName = busNo.length > 31 ? busNo.slice(0, 31) : busNo;
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusRoutes_BusWise_${today}.xlsx`);

    toast.success("Report Generated");
  };

  const handleExportBusRoutesStoppageWiseExcel = () => {
    if (!busRoute || busRoute.length === 0) {
      toast.error("No bus route data to export");
      return;
    }

    const groupedByStoppage = busRoute.reduce((acc, route) => {
      const stoppage = route.stoppage || "Unknown";
      if (!acc[stoppage]) acc[stoppage] = [];
      acc[stoppage].push(route);
      return acc;
    }, {});

    const workbook = XLSX.utils.book_new();
    const usedSheetNames = new Set();

    Object.entries(groupedByStoppage).forEach(([stoppage, routes]) => {
      const sortedRoutes = routes.sort((a, b) => {
        const numA = parseInt(a.busNo, 10) || 0;
        const numB = parseInt(b.busNo, 10) || 0;
        return numA - numB;
      });

      const sheetData = sortedRoutes.map((route) => ({
        "Bus No": route.busNo || "",
        "Vehicle No": route.vehicleNumber || "",
        Preference: route.preference || "",
        Stoppage: route.stoppage || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(sheetData);

      const sheetName = getUniqueSheetName(stoppage, usedSheetNames);
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusRoutes_StoppageWise_${today}.xlsx`);

    toast.success("Report Generated");
  };

  const handleExportBusRoutesPreferenceWiseExcel = () => {
    if (!busRoute || busRoute.length === 0) {
      toast.error("No bus route data to export");
      return;
    }

    const groupedByPreference = busRoute.reduce((acc, route) => {
      const preference = route.preference || "Unknown";
      if (!acc[preference]) acc[preference] = [];
      acc[preference].push(route);
      return acc;
    }, {});

    const workbook = XLSX.utils.book_new();
    const usedSheetNames = new Set();

    Object.entries(groupedByPreference).forEach(([preference, routes]) => {
      const sortedRoutes = routes.sort((a, b) => {
        const numA = parseInt(a.busNo, 10) || 0;
        const numB = parseInt(b.busNo, 10) || 0;
        return numA - numB;
      });

      const sheetData = sortedRoutes.map((route) => ({
        "Bus No": route.busNo || "",
        "Vehicle No": route.vehicleNumber || "",
        Preference: route.preference || "",
        Stoppage: route.stoppage || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(sheetData);
      const sheetName = getUniqueSheetName(preference, usedSheetNames);

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `BusRoutes_PreferenceWise_${today}.xlsx`);

    toast.success("Preference Wise Report Generated");
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div
            id="addRouteModal"
            className="modal fade gd-example-modal-lg"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <form onSubmit={handleSubmit}>
                  <div class="modal-header d-flex justify-content-between">
                    <h5 class="modal-title fs-4" id="exampleModalToggleLabel">
                      Add Route{" "}
                      <span className="ms-3 text-secondary">
                        ({String(filledFields).padStart(2, "0")}/
                        {String(totalFields).padStart(2, "0")})
                      </span>
                    </h5>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                  </div>

                  <div class="modal-body">
                    <div className="row g-2 mb-2">
                      <div className="col-lg-6 col-12">
                        <label class="form-label mb-1 ms-3" for="projectTitle">
                          Bus No <span class="text-danger">*</span>
                        </label>
                        <Select
                          name="busNo"
                          value={
                            busDetails
                              .map((bus) => ({
                                label: bus.generalInfo.busNumber,
                                value: bus.generalInfo.busNumber,
                              }))
                              .sort(
                                (a, b) => parseInt(a.value) - parseInt(b.value)
                              )
                              .find((opt) => opt.value === formData.busNo) ||
                            null
                          }
                          onChange={(selected) =>
                            handleChange({
                              target: {
                                name: "busNo",
                                value: selected?.value || "",
                              },
                            })
                          }
                          options={busDetails
                            .map((bus) => ({
                              label: bus.generalInfo.busNumber,
                              value: bus.generalInfo.busNumber,
                            }))
                            .sort(
                              (a, b) => parseInt(a.value) - parseInt(b.value)
                            )}
                          placeholder="Select Bus Number"
                        />
                      </div>
                      <div className="col-lg-6 col-12">
                        <label class="form-label mb-1 ms-3" for="projectTitle">
                          Preference <span class="text-danger">*</span>
                        </label>
                        <Select
                          name="preference"
                          value={
                            ["All", "Boys", "Girls"]
                              .map((item) => ({ label: item, value: item }))
                              .find(
                                (opt) => opt.value === formData.preference
                              ) || null
                          }
                          onChange={(selected) =>
                            handleChange({
                              target: {
                                name: "preference",
                                value: selected?.value || "",
                              },
                            })
                          }
                          options={["All", "Boys", "Girls"].map((item) => ({
                            label: item,
                            value: item,
                          }))}
                          placeholder="Select Preference"
                        />
                      </div>
                      <div className="col-lg-6 col-12">
                        <label class="form-label mb-1 ms-3" for="projectTitle">
                          Stoppage <span class="text-danger">*</span>
                        </label>
                        <Select
                          name="stoppage"
                          value={
                            busStoppageDetails
                              .map((stop) => ({
                                label: stop.stoppage,
                                value: stop.stoppage,
                              }))
                              .sort((a, b) => a.label.localeCompare(b.label))
                              .find((opt) => opt.value === formData.stoppage) ||
                            null
                          }
                          onChange={(selected) =>
                            handleChange({
                              target: {
                                name: "stoppage",
                                value: selected?.value || "",
                              },
                            })
                          }
                          options={busStoppageDetails
                            .map((stop) => ({
                              label: stop.stoppage,
                              value: stop.stoppage,
                            }))
                            .sort((a, b) => a.label.localeCompare(b.label))}
                          placeholder="Select Stoppage"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer d-flex justify-content-between py-2">
                    <div>
                      <button
                        type="button"
                        class="btn btn-secondary px-3 me-1 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                      <button
                        type="submit"
                        class="btn btn-primary px-5 rounded-pill fw-normal"
                        disabled={loading}
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="">
            <div class="container-fluid my-3 px-3">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                    <table class="table mb-0 text-nowrap table-centered">
                      <thead class="table-light">
                        <tr>
                          <th className="w-10">No.</th>
                          <th className="lh-1 w-60">
                            Details
                            <i className="bi bi-info-circle ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Displaying Information as per Record
                            </span>
                          </th>
                          <th className="lh-1 w-30">
                            Action
                            <i className="bi bi-person-gear ms-2 text-dark"></i>
                            <br />
                            <span className="fs-8 fw-normal text-secondary">
                              Role-Specific Action Panel
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((route, index) => (
                          <tr key={index}>
                            <td>{indexOfFirstRecord + index + 1}.</td>
                            <td className="lh-sm py-4 text-wrap">
                              <span class="text-dark">Bus No</span> &mdash;{" "}
                              {route.busNo}
                              <br />
                              <span class="text-dark">
                                Vehicle No
                              </span> &mdash; {route.vehicleNumber}
                              <br />
                              <span class="text-dark">
                                Preference
                              </span> &mdash; {route.preference} <br />
                              <span class="text-dark">
                                Stoppage
                              </span> &mdash;{" "}
                              <span className="text-capitalize">
                                {route.stoppage}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1 width-fit-content">
                                <span
                                  onClick={() => handleEditClick(route)}
                                  class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Update
                                </span>
                                <span
                                  onClick={() => handleDelete(route.id)}
                                  class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                >
                                  Delete
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div class="">
                    <div className="mb-3">
                      <div className="d-flex bg-white justify-content-between rounded-4">
                        <form
                          className="d-flex align-items-center"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="position-absolute ps-3 search-icon">
                            <i className="bi bi-filter-circle-fill ms-1" />
                          </span>
                          <input
                            type="search"
                            className="form-control ps-7 rounded-3 border-0 rounded-4"
                            placeholder="Filter Data"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </form>
                        <Link
                          data-bs-toggle="modal"
                          onClick={resetForm}
                          data-bs-target=".gd-example-modal-lg"
                          class="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                        >
                          Add Route
                        </Link>
                      </div>
                      <div className="mt-2 ms-4">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb pe-3">
                            <li class="breadcrumb-item">
                              <a href="#">Transport Management</a>
                            </li>
                            <li
                              class="breadcrumb-item active"
                              aria-current="page"
                            >
                              Bus Route
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                    <div className="p-4 bg-white rounded-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          {loading ? (
                            <div
                              className="spinner-border text-dark data-loader-spinner"
                              role="status"
                            ></div>
                          ) : (
                            <img src="/assets/images/folder.svg" />
                          )}

                          <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                            Bus Route
                            <br />
                            <span className="text-secondary fs-6 fw-medium lh-sm">
                              1.4 MB Size
                            </span>
                          </p>
                        </div>
                        <span
                          onClick={handleExportExcel}
                          className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer"
                        >
                          Export
                        </span>
                      </div>

                      <div class="px-4 py-2 mt-3 bg-light rounded-4">
                        <li className="list-group-item px-0">
                          <a
                            className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                            data-bs-toggle="collapse"
                            href="#specifications"
                            role="button"
                            aria-expanded="false"
                            aria-controls="specifications"
                          >
                            <p className="m-0 fw-medium lh-sm text-dark">
                              Download Report
                            </p>
                            <span className="chevron-arrow ms-4">
                              <i className="bi bi-chevron-down fs-4" />
                            </span>
                          </a>
                          <div
                            className="collapse"
                            id="specifications"
                            data-bs-parent="#ecommerceAccordion"
                          >
                            <div className="py-3">
                              <div class="rounded-4 d-flex flex-wrap">
                                <span
                                  onClick={handleExportBusRoutesExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  All Bus Routes
                                </span>
                                <span
                                  onClick={handleExportBusRoutesBusWiseExcel}
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Bus Wise Report
                                </span>
                                <span
                                  onClick={
                                    handleExportBusRoutesStoppageWiseExcel
                                  }
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Stoppage Wise Report
                                </span>
                                <span
                                  onClick={
                                    handleExportBusRoutesPreferenceWiseExcel
                                  }
                                  class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                >
                                  Preference Wise Report
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>

                    <div className="my-4">
                      <nav>
                        <ul className="pagination justify-content-center mb-0">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={prevPage}>
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          </li>

                          {(() => {
                            const pageNumbers = [];
                            pageNumbers.push(1);

                            if (currentPage > 3) {
                              pageNumbers.push("left-ellipsis");
                            }

                            if (
                              currentPage !== 1 &&
                              currentPage !== totalPages
                            ) {
                              pageNumbers.push(currentPage);
                            }

                            if (currentPage < totalPages - 2) {
                              pageNumbers.push("right-ellipsis");
                            }

                            if (totalPages > 1) {
                              pageNumbers.push(totalPages);
                            }

                            return pageNumbers.map((page, index) => {
                              if (
                                page === "left-ellipsis" ||
                                page === "right-ellipsis"
                              ) {
                                return (
                                  <li
                                    key={index}
                                    className="page-item disabled"
                                  >
                                    <span className="page-link">...</span>
                                  </li>
                                );
                              }

                              return (
                                <li
                                  key={index}
                                  className={`page-item ${
                                    currentPage === page ? "active" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(page)}
                                  >
                                    {page}
                                  </button>
                                </li>
                              );
                            });
                          })()}

                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button className="page-link" onClick={nextPage}>
                              <i className="bi bi-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default BusRoute;
